module.exports = __webpack_public_path__ + "img/italics.78f0e4c7.svg";